export function openAPIErrorCallback(error) {
  if (error.response && error.response.data) {
    let message = '';
    const { data } = error.response;

    if (data.meta && data.meta.error_message) {
      message = data.meta.error_message;
    } else {
      message = error.message;
    }
    return Promise.reject({
      message,
      data,
    });
  }
  return Promise.reject({
    message: error.message,
  });
}
